import { useEffect, useState } from 'react';

/**
 * useOnline — реактивно следит за статусом сети через `navigator.onLine`
 * и события `online`/`offline`.
 *
 * SSR-safe: вне браузера возвращает true. В тестах под happy-dom
 * navigator.onLine = true по умолчанию, что соответствует поведению
 * браузера в нормальном режиме.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(() => {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
  });

  useEffect(() => {
    function goOnline() {
      setOnline(true);
    }
    function goOffline() {
      setOnline(false);
    }
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
